import throttle from 'lodash-es/throttle'
import Vue from 'vue'
import i18n from '@/i18n'
import router from '@/router'
import apiService from '@/state/services/Api'

const app = {
  namespaced: true,
  state: {
    isApiFetching: false,
    version: process.env.VUE_APP_VERSION,
    name: process.env.VUE_APP_NAME,
    motto: process.env.VUE_APP_MOTTO,
    support: JSON.parse(process.env.VUE_APP_SUPPORT),
    fetchError: false,
    gridLimit: 100
  },
  getters: {
    gridLimit(state){
      return state.gridLimit
    },
    pageTitle(state, getters, rootState) {
      return i18n.t(`mygwf.views.${rootState.route.name}.title`)
    },
    documentTitle(state) {
      return name => `${i18n.t(`mygwf.views.${name}.title`)} - ${state.name}`
    },
    isGuestRoute(state, getters, rootState) {
      return rootState.route ? rootState.route.meta.guest : true
    },
    isApiFetching(state) {
      return state.isApiFetching
    },
    fetchError(state) {
      return state.fetchError
    },
    hasNotification(state) {
      return false
    },
    name(state) {
      return state.name
    },
    version(state) {
      return state.version
    },
    motto(state) {
      return state.motto
    },
    support(state) {
      return state.support[i18n.locale] ? state.support[i18n.locale] : state.support['en']
    },
    queryAll(state, getters, rootState) {
      return {query: {...rootState.route.query, limit: 99999, offset: 0}}
    },
  },
  mutations: {
    CHANGE_LOCALE(state, payload) {
      //plugins/boot.js
    },
    START_API_CALL(state) {
      state.fetchError = false
      state.isApiFetching = true
    },
    FINISH_API_CALL(state) {
      state.isApiFetching = false
    },
    ERROR_API_CALL(state) {
      state.fetchError = true
    },
  },
  actions: {
    notification({commit, dispatch}, {group, text, type}) {
      return Vue.notify({
        group,
        text,
        type,
      })
    },

    changeLocale({commit, dispatch}, payload) {
      commit('CHANGE_LOCALE', payload)
    },

    navigate({rootState}, payload) {
      const id = payload.comm_mod_uuid || payload.user_uuid || payload.id || payload.uuid
      return router.push({path: `${rootState.route.path}/${id}`})
    },

    filterProp: throttle(
      ({getters, rootState}, {value, name}) => {
        let query = {...rootState.route.query}
        if (Array.isArray(name)) {
          name.forEach((n, i) => {
            if (value[i]) {
              query[n] = value[i]
            } else {
              delete query[n]
            }
          })
        } else if (value === 'undefined' || value === '' || value?.length === 0) {
          delete query[name]
        } else {
          query[name] = value
        }

        // console.log(query, value, name)
        // if (
        //   query.limit &&
        //   Object.keys(query).length === 2 &&
        //   parseInt(query.offset) === 0 &&
        //   parseInt(query.limit) === 99999
        // ) {
        //   delete query.offset
        //   delete query.limit
        // }
        delete query.offset
        delete query.limit

        router.push({query})
      },
      300,
      {leading: false, trailing: true}
    ),

    simulate(context, payload) {
      if (payload.success) {
        return Promise.resolve()
      }
      return Promise.reject()
    },

    apiHasErrored({commit}) {
      commit('ERROR_API_CALL')
    },

    startApiCall({commit}) {
      commit('START_API_CALL')
    },

    finishApiCall({commit}) {
      commit('FINISH_API_CALL')
    },
  },
}

export default app
